<app-header></app-header>
<div class="responsive">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-3">
        <app-sidebar></app-sidebar>
      </div>
      <div class="col-md-9">
        <div class="row">

          <div class="col-md-12">
            <div class="section-bar margin-b">
              <button class="icon-btn" title="Back">
                <i class="fas fa-arrow-left"></i>
              </button>
              <div class="section-title">Staff Manager</div>
              <button class="btn btn-sm section-action" (click)="openAddStaff(addStaffModal)">
                <i class="fas fa-user-plus"></i> Add Staff
              </button>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="min-height">
              <div *ngIf="!loading" class="accordion" id="accordionExample">
                <div class="card" *ngFor="let props of arr; let i = index">
                  <div class="card-header" id="heading{{i}}">
                    <h2 class="mb-0">
                      <button class="btn btn-block text-left " type="button" data-toggle="collapse"
                        attr.data-target="#collapse{{i}}" aria-expanded="true" aria-controls="collapse{{i}}">
                        <app-skelton></app-skelton>
                      </button>
                    </h2>
                  </div>

                  <div id="collapse{{i}}" class="collapse " aria-labelledby="heading{{i}}"
                    data-parent="#accordionExample">
                    <div class="card-body">
                      <app-skelton></app-skelton>
                    </div>
                  </div>
                </div>


              </div>


              <div *ngIf="staffArr?.length === 0" class="card">
                <div class="card-body text-center" style="color:#6c757d; font-weight:500;">
                  No staff record found
                </div>
              </div>

              <div id="accordion" *ngIf="staffArr?.length > 0">
                <div class="card" *ngFor="let props of staffArr; let i = index">
                  <div class="card-header main-backgroundcolor" id="heading{{i}}">
                    <h5 class="mb-0">
                      <button class="btn btn-block text-left color" type="button" data-toggle="collapse"
                      attr.data-target="#collapse{{i}}" [class.collapsed]="i !== 0" [attr.aria-expanded]="i === 0 ? 'true' : 'false'" attr.aria-controls="collapse{{i}}">
                        <i class="fas fa-chevron-down twisty mr-2"></i>{{props?.staffType?.name}}
                      </button>
                    </h5>
                  </div>

                  <div attr.id="collapse{{i}}" class="collapse" [ngClass]="{'show': i === 0}"  data-parent="#accordion">
                    <div *ngIf ="props.staffId.length == 0">
                      <div class="card-body">
                               No result found
                      </div>
                    </div>
                    <div *ngIf ="props.staffId.length != 0">
                    <div class="card-body" *ngFor="let innerprops of props.staffId">
                      <div class="main-body ">



                        <div class="card-box margin-b">
                          <div class="card margin-b">

                            <div class="card-body  border-r">
                              <div class="box">

                                <div class="image-box">
                                  <div class="image-wrapper">
                                    <img src="assets/church_image.jpg">
                                  </div>
                                </div>


                                <div class="text-detail">
                                  <h5 class="card-title">{{innerprops?.name}}</h5>
                                  <p class="card-text">{{innerprops?.logLine}}</p>
                                </div>
                              </div>
                              <div class="footer">
                                <div>

                                  <button type="button" class="btn btn-update btn-textcolor"
                                    (click)="open(mymodal,innerprops)"><span><i
                                        class="fas fa-edit margin-r "></i></span>Update</button>
                                  <button type="button" (click) ="deleteStaff(props._id,innerprops)" class="btn btn-delete margin-l btn-textcolor"><span><i
                                        class="fas fa-trash-alt margin-r" ></i></span>Delete</button>
                                </div>

                              </div>


                            </div>

                          </div>



                        </div>

                      </div>
                    </div>
                    </div>
                  </div>
                </div>





                <!-- <div class="card">
                                  <div class="card-header" id="headingTwo">
                                    <h5 class="mb-0">
                                      <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                        Collapsible Group Item #2
                                      </button>
                                    </h5>
                                  </div>
                                  <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordion">
                                    <div class="card-body">
                                      Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.
                                    </div>
                                  </div>
                                </div>
                                <div class="card">
                                  <div class="card-header" id="headingThree">
                                    <h5 class="mb-0">
                                      <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                        Collapsible Group Item #3
                                      </button>
                                    </h5>
                                  </div>
                                  <div id="collapseThree" class="collapse" aria-labelledby="headingThree" data-parent="#accordion">
                                    <div class="card-body">
                                      Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.
                                    </div>
                                  </div>
                                </div> -->
              </div>



            </div>

          </div>
        </div>

      </div>

    </div>
  </div>
</div>


<ng-template #mymodal let-modal>
  <div class="modal-header main-backgroundcolor">
    <h4 class="modal-title color" id="modal-basic-title">Staff List </h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true" class="color">&times;</span>
    </button>
  </div>
  <div class="modal-body">


    <div *ngIf="!loadingModel">
        <div class="card" *ngFor="let props of arr; let i = index">

          <div class="card-header" id="heading{{i}}">
            <h2 class="mb-0">
              <button class="btn btn-block text-left" type="button" data-toggle="collapse"
                attr.data-target="#collapse{{i}}" aria-expanded="true" aria-controls="collapse{{i}}">
                <app-skelton></app-skelton>
              </button>
            </h2>
          </div>

          <div id="collapse{{i}}" class="collapse " aria-labelledby="heading{{i}}"
            data-parent="#accordionExample">
            <div class="card-body">
              <app-skelton></app-skelton>
            </div>
          </div>
        </div>
      <!-- <div  class="display margin-b" style="justify-content: space-between;border: 1px solid #b0b0b0;
    " *ngFor="let props of arr; let i = index">
      <div class="header" style="background-color: transparent; color: #000;">
        <app-skelton></app-skelton>
      </div>
      <div style="padding: 10px;">
       
      </div>
    </div> -->
    </div>


    <!-- 
    <div *ngIf="loading == false">
      <app-card-skelton *ngFor="let props of arr"></app-card-skelton>
    </div> -->

    <div *ngIf="loadingModel">
      <div class="display margin-b" style="justify-content: space-between;border: 1px solid #b0b0b0;
        " *ngFor="let item of loadMoreArr; let i = index">
        <div class="header" style="background-color: transparent; color: #000;">
          {{item.name}}
        </div>
        <div style="padding: 10px;">
          <input type="radio" [value]="item.name" (change)="selectItem($event,item);modal.close('Save click')" class="form-check-input"
            name="optradio">
        </div>
      </div>
    </div>

    <h6 *ngIf="showError" class="error">{{modalError}}</h6>

  </div>
  <!-- <div class="modal-footer">
   

    <button type="button" class="btn color main-backgroundcolor btn-sm pull-right"
      (click)="select();modal.close('Save click')">
      Select</button>
  </div> -->
</ng-template>

<!-- User Selector Modal -->
<ng-template #userSelectorModal let-modal>
  <div class="modal-header main-backgroundcolor">
    <h4 class="modal-title color">Select User</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true" class="color">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="form-group">
      <input type="text" class="form-control" placeholder="Search by name or email" (input)="onUserSearchChange($event)">
    </div>
    <div *ngIf="filteredUsers?.length === 0" class="text-center text-muted">No users found</div>
    <div *ngFor="let u of filteredUsers" class="card margin-b">
      <div class="card-body d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center">
          <img [src]="u.photo ? (u.photo) : 'assets/images/church.jpeg'" (error)="$event.target.src='assets/images/church.jpeg'" alt="" style="width:40px;height:40px;border-radius:50%;object-fit:cover;margin-right:10px;">
          <div>
            <div style="font-weight:600;">{{ u.name }}</div>
            <div class="text-muted small">{{ u.email }}</div>
          </div>
        </div>
        <div>
          <input type="checkbox" [checked]="isUserSelected(u._id)" (change)="toggleUserSelection(u)">
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss('cancel')">Cancel</button>
    <button type="button" class="btn main-backgroundcolor color" (click)="modal.close('selected')">Select</button>
  </div>
</ng-template>

<!-- Add Staff Modal -->
<ng-template #addStaffModal let-modal>
  <div class="modal-header main-backgroundcolor">
    <h4 class="modal-title color">Add Staff</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true" class="color">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="form-group">
      <label>Staff Type</label>
      <select class="form-control" (change)="onSelectStaffType($event)">
        <option value="" selected disabled>Choose staff type</option>
        <option *ngFor="let t of staffTypeOptions" [value]="t._id">{{ t.name }}</option>
      </select>
    </div>

    <div class="form-group">
      <label>Name</label>
      <div class="input-group">
        <input type="text" class="form-control" [value]="name || ''" placeholder="Choose individual" readonly (click)="openUserSelector(userSelectorModal)">
        <div class="input-group-append">
          <button type="button" class="btn main-backgroundcolor color" (click)="openUserSelector(userSelectorModal)">
            Select
          </button>
        </div>
      </div>
      <small class="text-muted" *ngIf="!name">No user selected</small>
    </div>

    <div *ngIf="showError" class="text-danger small">Please select both fields.</div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss('cancel')">Cancel</button>
    <button type="button" class="btn main-backgroundcolor color" (click)="submitAddStaff(modal)">Add</button>
  </div>
</ng-template>














<router-outlet></router-outlet>